module.exports = __webpack_public_path__ + "static/media/close-icon.055e5d3a.svg";